import axios from "axios";
import { awsUrl, url, newApiBaseUrl } from "../../axiosInstance";
import * as actionType from "../store/action";
import { type } from "@testing-library/user-event/dist/type";

export const getStationsFromPGW = () => {
  return axios.get(`${newApiBaseUrl}/common/locations`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `bearer ${localStorage.jwtToken}`,
      "X-Tenant": "hamazon",
    },
  });
};

export const GetStation = (id) => {
  id = id === "678430" ? 4 : id;
  return axios.get(`${awsUrl}/v1/stations/${id}`, {
    headers: {
      Authorization: `bearer ${localStorage.jwtToken}`,
    },
  });
};

export const NewStationEdit = (data) => {
  return axios.post(`${newApiBaseUrl}/admin/locations`, data, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `bearer ${localStorage.jwtToken}`,
      "X-Tenant": "hamazon",
    },
  });
};

export const GetStationsToUser = (userId) => {
  return axios.get(`${awsUrl}/v1/admin/stations`, {
    headers: {
      Authorization: `bearer ${localStorage.jwtToken}`,
    },
  });
};

export const getColumns = (stationId) => {
  return axios.get(
    `${url}LocationColumn/GetColumns?stationId=${stationId}&all=true`,
    {
      headers: {
        Authorization: `bearer ${localStorage.token}`,
        "Access-Control-Allow-Origin": "*",
      },
    },
  );
};

export const setRowsNew = (
  StationId,
  Quantity,
  LocationColumnId,
  LocationRowId,
) => {
  return axios.post(
    `${url}LocationColumn/AddNewRows`,
    { StationId, Quantity, LocationColumnId, LocationRowId },
    {
      headers: {
        Authorization: `bearer ${localStorage.token}`,
        "Access-Control-Allow-Origin": "*",
      },
    },
  );
};
export const AddNewCells = (
  StationId,
  Quantity,
  LocationColumnId,
  LocationRowId,
) => {
  return axios.post(
    `${url}LocationColumn/AddNewCells`,
    { StationId, Quantity, LocationColumnId, LocationRowId },
    {
      headers: {
        Authorization: `bearer ${localStorage.token}`,
        "Access-Control-Allow-Origin": "*",
      },
    },
  );
};
export const setColumnsNew = (StationId, Quantity) => {
  return axios.post(
    `${url}LocationColumn/AddNewColumns`,
    { StationId, Quantity },
    {
      headers: {
        Authorization: `bearer ${localStorage.token}`,
        "Access-Control-Allow-Origin": "*",
      },
    },
  );
};

export const getRows = (columnId) => {
  return axios.get(
    `${url}LocationColumn/GetRows?columnId=${columnId}&all=true`,
    {
      headers: {
        Authorization: `bearer ${localStorage.token}`,
        "Access-Control-Allow-Origin": "*",
      },
    },
  );
};

export const geCells = (rowId) => {
  return axios.get(`${url}LocationColumn/GetCells?rowId=${rowId}&all=true`, {
    headers: {
      Authorization: `bearer ${localStorage.token}`,
      "Access-Control-Allow-Origin": "*",
    },
  });
};

export const saveColm = (data) => {
  return axios.post(`${url}LocationColumn/SaveColumnInfo`, data, {
    headers: {
      Authorization: `bearer ${localStorage.token}`,
      "Access-Control-Allow-Origin": "*",
    },
  });
};
export const saveCells = (data) => {
  return axios.post(`${url}LocationColumn/SaveCellInfo`, data, {
    headers: {
      Authorization: `bearer ${localStorage.token}`,
      "Access-Control-Allow-Origin": "*",
    },
  });
};
export const SaveRowInfo = (data) => {
  return axios.post(`${url}LocationColumn/SaveRowInfo`, data, {
    headers: {
      Authorization: `bearer ${localStorage.token}`,
      "Access-Control-Allow-Origin": "*",
    },
  });
};

export const AddNewCell = (data) => {
  return axios.post(`${url}LocationColumn/AddNewCell`, data, {
    headers: {
      Authorization: `bearer ${localStorage.token}`,
      "Access-Control-Allow-Origin": "*",
    },
  });
};
